import { render, staticRenderFns } from "./NewMessageAudioRecorder.vue?vue&type=template&id=ba7c4250&scoped=true"
import script from "./NewMessageAudioRecorder.vue?vue&type=script&lang=js"
export * from "./NewMessageAudioRecorder.vue?vue&type=script&lang=js"
import style0 from "./NewMessageAudioRecorder.vue?vue&type=style&index=0&id=ba7c4250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7c4250",
  null
  
)

export default component.exports